<template lang="pug">
	.station--computer-detail.flex-col.full-width
		.flex-1.flex-col.space-large
			slot(name="actions-top")
			.flex-row.justify.align-center
				.font-big.upper {{$tCaption('Station computer')}}
				.right.flex-row.space.align-center
					slot(name='actions-right')
			.flex-row.space-large
				.flex-col.space
					.font-small.upper.grey {{$tCaption('№')}}
					.font-big {{record.ComputerNumber}}
				.flex-col.space
					.font-small.upper.grey {{$tCaption('Reverse SSH port')}}
					.font-big {{record.ReverseSshPort}}
				.flex-col.space
					.font-small.upper.grey {{$tCaption('Last seen')}}
					.font-big {{$Data.formatDate(record.LastSeen, 'LLL')}}
				.flex-col.space
					.font-small.upper.grey {{$tCaption('First seen')}}
					.font-big {{$Data.formatDate(record.FirstSeen, 'LLL')}}
				.flex-col.space
					.font-small.upper.grey {{$tCaption('SSID')}}
					.font-big {{record.SSID}}
			slot(name="actions-bottom")
</template>

<script>

	export default {
		translationCategory: 'station.StationComputer',
		name: 'station--computer-detail',
		props: ['record'],
		data() {
			return {
			};
		},
		mounted() {
			if (__DEBUG__)
				window.stationComputer = this;
		},
		methods: {
		}
	};
</script>
<style lang='scss'>
	.station--computer-detail {
		
	}
</style>
